import { IUserContext, UserContext } from './user-context.model';
import { IToken } from '../dtos/responses/token.response';
import { Token } from './token.model';

export interface IUserStorage {
    token: IToken;
    userContext: IUserContext;
}

export class UserStorage {
    token: Token;
    userContext: UserContext;

    private constructor(userStorage: IUserStorage) {
        this.token = Token.create(userStorage.token);
        this.userContext = UserContext.create(userStorage.userContext);
    }

    static create(userStorage: IUserStorage) {
        return new UserStorage(userStorage);
    }
}
